
import link from './configurable-chart.link';

export default function configurableChart () {
	return {
		restrict:'E',
		scope: {
			config: '='
		},
		template: '<canvas></canvas>',
		replace: true,
		link
	};
};

configurableChart.$inject = [];



// WEBPACK FOOTER //
// ./src/directive/configurable-chart/configurable-chart.js